var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourceTable',{attrs:{"loading":_vm.$fetchState.pending,"schema":_vm.schema,"rows":_vm.rows,"create-able":true,"overflow-y":true}})}
var staticRenderFns = []

export { render, staticRenderFns }